export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Final2_03.a0135a60.jpg";